// src/services/api.ts
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://tatai-copilot.tat.or.th/be';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
